var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlightDeparture = function SvgFlightDeparture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.556 6.116 4.36 15.232 1 11.656l1.173-.721a.85.85 0 0 1 .89 0l2.257 1.204 4.667-2.447L3.31 5.897 4.93 4l10.56 2.903 6.035-2.685c1.263-.265 1.974 1.091 1.005 1.898",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.782 19.975H1.01v1.006h16.773z"
  })));
};
export default SvgFlightDeparture;